import React from "react";
import { Box, Skeleton, alpha, useTheme } from "@mui/material";

const ClientListSkeleton = ({ count = 5 }) => {
  const theme = useTheme();

  return (
    <Box sx={{ p: 1 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            p: 2,
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={20} />
          </Box>
          <Skeleton variant="rectangular" width={80} height={30} sx={{ borderRadius: 1 }} />
        </Box>
      ))}
    </Box>
  );
};

export default ClientListSkeleton;